import { render, staticRenderFns } from "./PurposeForm.vue?vue&type=template&id=df8a7998&"
import script from "./PurposeForm.vue?vue&type=script&lang=js&"
export * from "./PurposeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports